export default __webpack_public_path__ + "static/media/factory__16.1614cc34.jpg";